<script setup lang="ts">
import IconShare from '~/components/icons/IconShare'
import type { EventDescription } from '~/composables/types/event'
const props = defineProps<{
  event: EventDescription
}>()
const isShareModalOpen = ref(false)
const { isMobile } = useDevice()
const route = useRoute()
const isGiftcard = eventGetters.isGiftcardEvent(props.event)
const { t } = useI18n()
const fullLocalizedUrl = useFullLocalizedUrl(true)

const toggleShareModalOpen = () => {
  isShareModalOpen.value = !isShareModalOpen.value
}
const handleOpenShare = () => {
  if (isMobile && navigator.share) {
    sendGalleryShareIntent(props.event, 'native')
    navigator
      .share({
        title: props.event.title,
        text: props.isGiftcard
          ? t('product.gallery.shareModal.shareGiftcardMessage')
          : t('product.gallery.shareModal.shareEventMessage'),
        url: `${route.path}?utm_source=konfetti&utm_medium=share_event&utm_campaign=mobile`,
      })
      .then(() => {
        sendGalleryShareNativeStatus(props.event, 'success')
      })
      .catch(() => {
        sendGalleryShareNativeStatus(props.event, 'cancelled')
      })
  } else {
    toggleShareModalOpen()
    sendGalleryShareIntent(props.event, 'browser')
  }
}

const shareLink = computed(() =>
  fullLocalizedUrl(
    `${route.path}?${encodeURIComponent(
      'utm_source=konfetti&utm_medium=share_event&utm_campaign=facebook'
    )}`
  )
)
</script>
<template>
  <div
    class="absolute top-2 md:top-4 md:left-1 z-1 flex gap-4 px-2 md:px-4 text-xs md:text-base"
  >
    <Button color="tertiary" @click.prevent="$emit('click:openPreviewModal')">
      {{ $t('product.seeAllImages') }}
    </Button>
    <Button
      color="tertiary"
      aria-label="Share"
      class="flex items-center gap-2 px-2 py-1 md:px-4"
      @click.prevent="handleOpenShare"
    >
      <IconShare size="16" />
      <span class="hidden md:inline-block">
        {{ $t('product.shareButton') }}
      </span>
    </Button>
    <ShareDialog
      :is-share-modal-open="isShareModalOpen"
      :is-giftcard="isGiftcard"
      :page-title="eventGetters.getTitle(event)"
      :link="shareLink"
      @shared="sendGalleryShareOption(event, $event)"
      @close="toggleShareModalOpen"
    />
  </div>
</template>
